import type { FaireThemeEntity } from "../../entity_types/theme";

export const board_demo_r_wd64rb2zkz_thi_05f7e152e9: FaireThemeEntity = {
  token: "board_demo_r_wd64rb2zkz_thi_05f7e152e9",
  type: "theme",
  retailerToken: "r_wd64rb2zkz",
  name: "Bespoke Newborn Surprises",
  description:
    "Build on your commitment to quality with a selection of artisanal and sustainably made toys that parents can trust for their little ones.",
  bgColor: "#F4EDE3",
  productTokens: [],
  coverImageUrl:
    "https://cdn.faire.com/fastly/8bc834c00fd306fe0276a48b4708a1c85e604cd236a779af632b812da759227f.jpeg",
  thumbnailImageUrls: [
    "https://cdn.faire.com/fastly/8bc834c00fd306fe0276a48b4708a1c85e604cd236a779af632b812da759227f.jpeg",
    "https://cdn.faire.com/fastly/4321390e4dbff2b6f9c27f243056012483ffdaec6e80d23c09e76e384333c2ed.jpeg",
    "https://cdn.faire.com/fastly/7fed7429374c2e448bcb191d78172aa716ba444dbf3b81a2a3ead8624394712c.jpeg",
    "https://cdn.faire.com/fastly/36fa444a5287c3b1f3d44e47c13219bba4652a7689051a8bdb43ab0df06cb2a0.jpeg",
    "https://cdn.faire.com/fastly/52b16d4cde1ae3f974994322dfae983aca2120d8c2ce55993e2a78a7f28d01c7.jpeg",
    "https://cdn.faire.com/fastly/f41d2581d18835dfaaa8557bcd87615899ccf3a5ce0d048b561bd436e33c5733.jpeg",
  ],
  itemCount: 65,
  source: "eric_themes_ideas",
  teaser: "thi_05f7e152e9",
  meta: {
    source: "mock",
    importedAt: "2026-04-19T23:00:00.000Z",
    importedBy: "board-demo-canonicalize",
  },
};
